import React from 'react'
import PropTypes from 'prop-types'

import Button from '@components/ui/Button'

const HelpFooter = ({ toggleModal }) => (
  <div className="text-center">
    <Button onClick={() => toggleModal()}>Close this popup window</Button>
  </div>
)

HelpFooter.propTypes = {
  toggleModal: PropTypes.func.isRequired,
}

export default HelpFooter
